import { render, staticRenderFns } from "./EnviarArquivoCell.vue?vue&type=template&id=01c97630&scoped=true"
import script from "./EnviarArquivoCell.vue?vue&type=script&lang=js"
export * from "./EnviarArquivoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c97630",
  null
  
)

export default component.exports